// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Video Layout
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

[data-media-player] .vds-video-layout:not([data-match]) {
  display: none !important;
}

[data-media-player][data-layout='video'] {
  background-color: var(--video-bg, black);
}

[data-media-player][data-layout='video']:not([data-fullscreen]) {
  border-radius: var(--video-border-radius, 6px);
  border: var(--video-border, 1px solid rgb(255 255 255 / 0.1));
}

:where(.vds-video-layout) {
  --media-brand: var(--video-brand, #f5f5f5);
  --media-font-family: var(--video-font-family, sans-serif);
  --media-controls-color: var(--video-controls-color, #f5f5f5);
  --media-tooltip-y-offset: 6px;
  --media-menu-y-offset: 6px;
  --media-focus-ring-color: var(--video-focus-ring-color, rgb(78 156 246));
  --media-focus-ring: var(--video-focus-ring, 0 0 0 3px var(--media-focus-ring-color));
  color: var(--video-controls-color, #f5f5f5);
  display: contents;
}

:where([data-media-player][data-focus]:not([data-playing]) .vds-video-layout .vds-controls) {
  border-radius: var(--video-border-radius, 6px);
  box-shadow: var(--media-focus-ring);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Controls
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout .vds-controls[data-visible]) {
  border-radius: var(--video-border-radius, 6px);
  background-image: linear-gradient(
    to top,
    rgb(0 0 0 / 0.6),
    10%,
    transparent,
    95%,
    rgb(0 0 0 / 0.3)
  );
}

.vds-video-layout .vds-controls-group {
  align-items: center;
  display: flex;
  pointer-events: auto;
  z-index: 0;
  padding: 4px 6px;
}

.vds-video-layout .vds-controls-group:first-child {
  z-index: 50;
}

/* second last group */
.vds-video-layout .vds-controls-group:nth-last-child(2) {
  padding: 0 12px;
  z-index: 11;
  margin-bottom: -16px;
}

.vds-video-layout:not([data-sm]) .vds-controls-group:last-child {
  --media-menu-y-offset: 26px;
  --media-tooltip-y-offset: 26px;
  --media-slider-preview-offset: 26px;
  z-index: 10;
}

:where(.vds-video-layout .vds-button) {
  margin-right: 2.5px;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Title
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout[data-sm] .vds-chapter-title) {
  font-size: var(--video-sm-chapter-title-font-size, 15px);
}

:where([data-fullscreen] .vds-video-layout .vds-chapter-title) {
  font-size: var(--video-fullscreen-chapter-title-font-size, 16px);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Buttons
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout:not([data-sm]) .vds-mute-button) {
  margin-left: -2.5px;
  margin-right: -5px;
}

:where(.vds-video-layout[data-sm]) {
  --media-button-size: var(--video-sm-button-size, 36px);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Sliders
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout .vds-time-slider) {
  --media-slider-height: 45px;
  flex-grow: 0;
}

:where(.vds-video-layout .vds-slider-thumbnail) {
  --media-thumbnail-border: var(--video-slider-thumbnail-border, 1px solid #f5f5f5);
  border-radius: var(--video-slider-thumbnail-border-radius, 2px);
}

.vds-video-layout .vds-time-slider .vds-slider-value {
  background-color: var(--video-time-bg, unset);
  text-shadow:
    -1px -1px 0 #333333,
    1px -1px 0 #333333,
    -1px 1px 0 #333333,
    1px 1px 0 #333333;
}

:where(.vds-video-layout[data-sm] .vds-time) {
  text-shadow: unset;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Large Layout Volume Slider
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout[data-lg] .vds-volume) {
  --gap: var(--video-volume-gap, 10px);
  display: contents;
}

:where(.vds-video-layout[data-lg] .vds-volume-popup) {
  display: contents;
}

:where(.vds-video-layout[data-lg] .vds-volume-slider) {
  margin: 0;
  max-width: 0;
  transition: all 0.15s ease;
}

:where(.vds-video-layout[data-lg] .vds-volume[data-active] .vds-volume-slider),
:where(.vds-video-layout[data-lg] .vds-volume:has([data-active]) .vds-volume-slider) {
  margin-left: var(--gap);
  opacity: 1;
  visibility: visible;
  max-width: var(--video-volume-slider-max-width, 72px);
}

/* safe area. */
.vds-video-layout[data-lg] .vds-volume-slider::after {
  content: '';
  position: fixed;
  top: 0;
  left: calc(-1 * var(--gap));
  width: var(--gap);
  height: 100%;
  z-index: 1;
  pointer-events: auto;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Small Layout Volume Slider
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout[data-sm] .vds-volume) {
  --media-slider-height: var(--video-volume-height, 96px);
  --media-slider-preview-offset: calc(-200% - 6px);
  --gap: var(--video-volume-gap, 10px);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

:where(.vds-video-layout[data-sm] .vds-volume-popup) {
  display: block;
  position: absolute;
  top: calc(100% + var(--gap));
  left: 50%;
  opacity: 0;
  transform: translateX(-50%);
  transition:
    opacity 150ms ease-out,
    visibility 150ms ease-out;
  border-radius: var(--video-volume-border-radius, 8px);
  filter: var(--media-volume-filter, drop-shadow(0 1px 1px rgb(0 0 0 / 0.05)));
  visibility: hidden;
}

/* safe area. */
.vds-video-layout[data-sm] .vds-mute-button::after {
  content: '';
  position: fixed;
  bottom: calc(-1 * var(--gap));
  right: 0;
  width: 100%;
  height: var(--gap);
  z-index: 1;
  pointer-events: auto;
}

.vds-video-layout .vds-volume-popup {
  background-color: var(--video-volume-bg, var(--media-menu-bg, var(--default-bg)));
  border: var(--video-volume-border, var(--default-border));
}

.light .vds-video-layout .vds-volume-popup,
.vds-video-layout.light .vds-volume-popup {
  --default-bg: rgb(250 250 250);
  --default-border: 1px solid rgb(10 10 10 / 0.1);
}

.dark .vds-video-layout .vds-volume-popup,
.vds-video-layout.dark .vds-volume-popup {
  --default-bg: rgb(10 10 10);
  --default-border: 1px solid rgb(255 255 255 / 0.1);
}

:where(.vds-video-layout[data-sm] .vds-volume[data-active] .vds-volume-popup),
:where(.vds-video-layout[data-sm] .vds-volume:has([data-active]) .vds-volume-popup) {
  transition:
    opacity 150ms ease-in,
    visibility 150ms ease-in;
  opacity: 1;
  visibility: visible;
}

:where(.vds-video-layout[data-sm] .vds-volume[data-active] .vds-tooltip-content) {
  display: none !important;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Time
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout .vds-time[data-type='current']) {
  margin-right: 2px;
}

:where(.vds-video-layout .vds-time[data-type='current'][remainder]) {
  margin-left: 2px;
}

.vds-video-layout .vds-time {
  --default-color: #f5f5f5 !important;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Captions
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where([data-preview] .vds-video-layout .vds-captions) {
  opacity: 0;
}

:where(.vds-video-layout .vds-captions) {
  z-index: 10;
  transition: var(--video-captions-transition, bottom 0.3s ease-in-out);
}

@media (min-width: 980px) {
  :where([data-fullscreen] .vds-video-layout .vds-captions) {
    bottom: var(--video-lg-fullscreen-captions-offset, 54px);
  }
}

:where([data-media-player][data-controls] .vds-video-layout .vds-captions) {
  bottom: var(--video-captions-offset, 78px);
}

:where([data-media-player][data-controls] .vds-video-layout[data-sm] .vds-captions) {
  bottom: var(--video-sm-captions-offset, 48px);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Chapters
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout .vds-time-slider .vds-slider-chapter-title) {
  width: 100%;
  text-align: center;
  text-shadow:
    -1px -1px 0 #212121,
    1px -1px 0 #212121,
    -1px 1px 0 #212121,
    1px 1px 0 #212121;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Gestures
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout .vds-gesture) {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

:where(.vds-video-layout .vds-gesture[action='seek:-10']) {
  width: var(--video-gesture-seek-width, 20%);
  z-index: 1;
}

:where(.vds-video-layout .vds-gesture[action='seek:10']) {
  left: unset;
  right: 0;
  width: var(--video-gesture-seek-width, 20%);
  z-index: 1;
}

@media (pointer: coarse) {
  :where(.vds-video-layout .vds-gesture[action='toggle:paused']) {
    display: none;
  }
}

@media not (pointer: coarse) {
  :where([data-media-player] .vds-video-layout .vds-gesture[action='toggle:controls']) {
    display: none;
  }
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Live Button
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout .vds-live-button) {
  margin-left: 12px;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Time Group
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout:not([data-sm]) .vds-time-group) {
  margin-left: 10px;
}

:where(.vds-video-layout[data-sm] .vds-time) {
  font-size: var(--video-sm-time-font-size, 14px);
}

:where([data-fullscreen] .vds-video-layout .vds-time) {
  font-size: var(--video-fullscreen-time-font-size, 16px);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Load Container
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout .vds-load-container) {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: none;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 99;
}

:where(
    [data-media-player][data-load='play']:not([data-started])
      .vds-video-layout[data-match]
      .vds-load-container
  ) {
  display: flex;
}

:where(.vds-video-layout .vds-load-container .vds-play-button) {
  --size: var(--video-load-button-size, 56px);
  --color: var(--video-load-button-color, rgb(0 0 0 / 0.8));
  --bg-color: var(--video-load-button-bg, var(--media-brand));

  --media-button-hover-transform: 0;
  --media-button-border: var(--video-load-button-border, var(--color));
  --media-button-hover-bg: var(--video-load-button-bg, var(--media-brand));

  width: var(--size);
  height: var(--size);
  pointer-events: auto;
  margin-bottom: 2px;
  overflow: hidden;
}

.vds-video-layout .vds-load-container .vds-play-button {
  border-radius: var(--video-load-button-border-radius, 100%);
  color: var(--color);
}

.vds-video-layout .vds-load-container .vds-play-button {
  background-color: var(--bg-color);
}

:where(.vds-video-layout[data-sm] .vds-load-container .vds-play-button) {
  --size: var(--video-sm-load-button-size, 48px);
  --media-button-hover-transform: translateY(0%);
  width: var(--size);
  height: var(--size);
  transform: translateY(0%);
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Small Layout
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where(.vds-video-layout[data-sm] .vds-controls-group:nth-last-child(2)) {
  pointer-events: none;
}

:where(.vds-video-layout[data-sm] .vds-controls-group:last-child) {
  z-index: 2;
  margin-top: -2.5px;
  margin-bottom: -6px;
}

:where([data-fullscreen] .vds-video-layout[data-sm] .vds-controls-group:last-child) {
  margin-bottom: 0;
}

.vds-video-layout[data-sm] .vds-controls-group {
  padding: 2px;
}

:where(.vds-video-layout[data-sm])
  :where(
    .vds-button,
    .vds-slider:not(.vds-time-slider),
    .vds-time,
    .vds-time-divider,
    .vds-chapter-title
  ) {
  transition: opacity 0.15s ease;
}

:where([data-media-player]:not([data-started]) .vds-video-layout[data-sm])
  :where(.vds-button .vds-slider, .vds-time-group) {
  opacity: 0;
  visibility: hidden;
}

:where(.vds-video-layout[data-sm] .vds-time-slider) {
  transition: transform 0.1s linear;
}

@media (pointer: coarse) {
  :where([data-preview] .vds-video-layout:not([data-no-scrub-gesture]))
    :where(
      .vds-button,
      .vds-slider:not(.vds-time-slider),
      .vds-time,
      .vds-chapter-title,
      .vds-time-divider,
      .vds-captions,
      .vds-live-button
    ) {
    opacity: 0;
  }

  :where([data-preview] .vds-video-layout:not([data-no-scrub-gesture]) .vds-time-slider) {
    --track-height: var(--video-sm-slider-focus-track-height, 12px);
    transform: translateY(-6px);
    transition: transform 0.1s linear;
  }
}

:where(.vds-video-layout[data-sm] .vds-controls .vds-play-button) {
  --size: var(--video-sm-play-button-size, 45px);
  --media-button-hover-transform: translateY(25%);
  width: var(--size);
  height: var(--size);
  transform: translateY(25%);
  border-radius: 100%;
  pointer-events: auto;
  margin-bottom: 2px;
  overflow: hidden;
}

.vds-video-layout[data-sm] .vds-controls .vds-play-button {
  background-color: var(--video-sm-play-button-bg, rgba(0 0 0 / 0.6));
}

:where(
    [data-media-player]:not([data-started])
      .vds-video-layout[data-sm]
      .vds-controls-group:not(:nth-child(3))
  ) {
  opacity: 0;
  visibility: hidden;
}

/* center big play button inside buffering indicator. */
:where(.vds-video-layout[data-sm] .vds-buffering-indicator) {
  --media-buffering-size: 64px;
  transform: translate(-2px, -4px);
}

:where(.vds-video-layout .vds-start-duration .vds-time) {
  position: absolute;
  right: 8px;
  bottom: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  z-index: 10;
}

.vds-video-layout .vds-start-duration .vds-time {
  padding: var(--video-sm-start-duration-padding, 3px 6px);
  color: var(--video-sm-start-duration-color, var(--video-controls-color));
  background-color: var(--video-sm-start-duration-bg, rgba(0 0 0 / 0.64));
}

:where([data-started] .vds-video-layout .vds-start-duration .vds-time) {
  display: none;
}

:where([data-media-player]:not([data-can-play]) .vds-video-layout .vds-start-duration .vds-time) {
  opacity: 0;
}

:where(.vds-video-layout[data-sm] .vds-time[data-type='current']) {
  margin-left: 8px;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Fullscreen
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

:where([data-fullscreen] .vds-video-layout .vds-controls-group:nth-last-child(2)) {
  margin-bottom: -16px;
}

@media (orientation: portrait) {
  :where([data-fullscreen] .vds-video-layout .vds-captions) {
    bottom: 30lvh;
    bottom: 10dvh;
  }
}

@media (orientation: landscape) {
  :where([data-fullscreen] .vds-video-layout .vds-controls-group:nth-last-child(2)) {
    margin-bottom: -12px;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@vidstack/react/player/styles/default/layouts/video.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,0CAA0C;EAC1C,yDAAyD;EACzD,4DAA4D;EAC5D,6BAA6B;EAC7B,0BAA0B;EAC1B,wEAAwE;EACxE,oFAAoF;EACpF,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;;;;EAIE;;AAEF;EACE,8CAA8C;EAC9C;;;;;;;GAOC;AACH;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE;;AAEF;EACE,wDAAwD;AAC1D;;AAEA;EACE,gEAAgE;AAClE;;AAEA;;;;EAIE;;AAEF;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;;;EAIE;;AAEF;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iFAAiF;EACjF,+DAA+D;AACjE;;AAEA;EACE,6CAA6C;EAC7C;;;;qBAImB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE;;AAEF;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;EAIE;;AAEF;EACE,uDAAuD;EACvD,gDAAgD;EAChD,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B;;6BAE2B;EAC3B,qDAAqD;EACrD,4EAA4E;EAC5E,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iFAAiF;EACjF,yDAAyD;AAC3D;;AAEA;;EAEE,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;;EAEE,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;;EAEE;;4BAE0B;EAC1B,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;EAIE;;AAEF;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qEAAqE;AACvE;;AAEA;EACE;IACE,wDAAwD;EAC1D;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;;EAIE;;AAEF;EACE,WAAW;EACX,kBAAkB;EAClB;;;;qBAImB;AACrB;;AAEA;;;;EAIE;;AAEF;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;;EAIE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;;;EAIE;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,yDAAyD;EACzD,2DAA2D;;EAE3D,iCAAiC;EACjC,oEAAoE;EACpE,wEAAwE;;EAExE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE;;AAEF;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;;;;;;;;;;IAUE,UAAU;EACZ;;EAEA;IACE,+DAA+D;IAC/D,2BAA2B;IAC3B,iCAAiC;EACnC;AACF;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;;;;;EAKE,UAAU;EACV,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wDAAwD;EACxD,wEAAwE;EACxE,uEAAuE;AACzE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE;;AAEF;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Video Layout\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n[data-media-player] .vds-video-layout:not([data-match]) {\n  display: none !important;\n}\n\n[data-media-player][data-layout='video'] {\n  background-color: var(--video-bg, black);\n}\n\n[data-media-player][data-layout='video']:not([data-fullscreen]) {\n  border-radius: var(--video-border-radius, 6px);\n  border: var(--video-border, 1px solid rgb(255 255 255 / 0.1));\n}\n\n:where(.vds-video-layout) {\n  --media-brand: var(--video-brand, #f5f5f5);\n  --media-font-family: var(--video-font-family, sans-serif);\n  --media-controls-color: var(--video-controls-color, #f5f5f5);\n  --media-tooltip-y-offset: 6px;\n  --media-menu-y-offset: 6px;\n  --media-focus-ring-color: var(--video-focus-ring-color, rgb(78 156 246));\n  --media-focus-ring: var(--video-focus-ring, 0 0 0 3px var(--media-focus-ring-color));\n  color: var(--video-controls-color, #f5f5f5);\n  display: contents;\n}\n\n:where([data-media-player][data-focus]:not([data-playing]) .vds-video-layout .vds-controls) {\n  border-radius: var(--video-border-radius, 6px);\n  box-shadow: var(--media-focus-ring);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Controls\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout .vds-controls[data-visible]) {\n  border-radius: var(--video-border-radius, 6px);\n  background-image: linear-gradient(\n    to top,\n    rgb(0 0 0 / 0.6),\n    10%,\n    transparent,\n    95%,\n    rgb(0 0 0 / 0.3)\n  );\n}\n\n.vds-video-layout .vds-controls-group {\n  align-items: center;\n  display: flex;\n  pointer-events: auto;\n  z-index: 0;\n  padding: 4px 6px;\n}\n\n.vds-video-layout .vds-controls-group:first-child {\n  z-index: 50;\n}\n\n/* second last group */\n.vds-video-layout .vds-controls-group:nth-last-child(2) {\n  padding: 0 12px;\n  z-index: 11;\n  margin-bottom: -16px;\n}\n\n.vds-video-layout:not([data-sm]) .vds-controls-group:last-child {\n  --media-menu-y-offset: 26px;\n  --media-tooltip-y-offset: 26px;\n  --media-slider-preview-offset: 26px;\n  z-index: 10;\n}\n\n:where(.vds-video-layout .vds-button) {\n  margin-right: 2.5px;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Title\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout[data-sm] .vds-chapter-title) {\n  font-size: var(--video-sm-chapter-title-font-size, 15px);\n}\n\n:where([data-fullscreen] .vds-video-layout .vds-chapter-title) {\n  font-size: var(--video-fullscreen-chapter-title-font-size, 16px);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Buttons\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout:not([data-sm]) .vds-mute-button) {\n  margin-left: -2.5px;\n  margin-right: -5px;\n}\n\n:where(.vds-video-layout[data-sm]) {\n  --media-button-size: var(--video-sm-button-size, 36px);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Sliders\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout .vds-time-slider) {\n  --media-slider-height: 45px;\n  flex-grow: 0;\n}\n\n:where(.vds-video-layout .vds-slider-thumbnail) {\n  --media-thumbnail-border: var(--video-slider-thumbnail-border, 1px solid #f5f5f5);\n  border-radius: var(--video-slider-thumbnail-border-radius, 2px);\n}\n\n.vds-video-layout .vds-time-slider .vds-slider-value {\n  background-color: var(--video-time-bg, unset);\n  text-shadow:\n    -1px -1px 0 #333333,\n    1px -1px 0 #333333,\n    -1px 1px 0 #333333,\n    1px 1px 0 #333333;\n}\n\n:where(.vds-video-layout[data-sm] .vds-time) {\n  text-shadow: unset;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Large Layout Volume Slider\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout[data-lg] .vds-volume) {\n  --gap: var(--video-volume-gap, 10px);\n  display: contents;\n}\n\n:where(.vds-video-layout[data-lg] .vds-volume-popup) {\n  display: contents;\n}\n\n:where(.vds-video-layout[data-lg] .vds-volume-slider) {\n  margin: 0;\n  max-width: 0;\n  transition: all 0.15s ease;\n}\n\n:where(.vds-video-layout[data-lg] .vds-volume[data-active] .vds-volume-slider),\n:where(.vds-video-layout[data-lg] .vds-volume:has([data-active]) .vds-volume-slider) {\n  margin-left: var(--gap);\n  opacity: 1;\n  visibility: visible;\n  max-width: var(--video-volume-slider-max-width, 72px);\n}\n\n/* safe area. */\n.vds-video-layout[data-lg] .vds-volume-slider::after {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: calc(-1 * var(--gap));\n  width: var(--gap);\n  height: 100%;\n  z-index: 1;\n  pointer-events: auto;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Small Layout Volume Slider\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout[data-sm] .vds-volume) {\n  --media-slider-height: var(--video-volume-height, 96px);\n  --media-slider-preview-offset: calc(-200% - 6px);\n  --gap: var(--video-volume-gap, 10px);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n:where(.vds-video-layout[data-sm] .vds-volume-popup) {\n  display: block;\n  position: absolute;\n  top: calc(100% + var(--gap));\n  left: 50%;\n  opacity: 0;\n  transform: translateX(-50%);\n  transition:\n    opacity 150ms ease-out,\n    visibility 150ms ease-out;\n  border-radius: var(--video-volume-border-radius, 8px);\n  filter: var(--media-volume-filter, drop-shadow(0 1px 1px rgb(0 0 0 / 0.05)));\n  visibility: hidden;\n}\n\n/* safe area. */\n.vds-video-layout[data-sm] .vds-mute-button::after {\n  content: '';\n  position: fixed;\n  bottom: calc(-1 * var(--gap));\n  right: 0;\n  width: 100%;\n  height: var(--gap);\n  z-index: 1;\n  pointer-events: auto;\n}\n\n.vds-video-layout .vds-volume-popup {\n  background-color: var(--video-volume-bg, var(--media-menu-bg, var(--default-bg)));\n  border: var(--video-volume-border, var(--default-border));\n}\n\n.light .vds-video-layout .vds-volume-popup,\n.vds-video-layout.light .vds-volume-popup {\n  --default-bg: rgb(250 250 250);\n  --default-border: 1px solid rgb(10 10 10 / 0.1);\n}\n\n.dark .vds-video-layout .vds-volume-popup,\n.vds-video-layout.dark .vds-volume-popup {\n  --default-bg: rgb(10 10 10);\n  --default-border: 1px solid rgb(255 255 255 / 0.1);\n}\n\n:where(.vds-video-layout[data-sm] .vds-volume[data-active] .vds-volume-popup),\n:where(.vds-video-layout[data-sm] .vds-volume:has([data-active]) .vds-volume-popup) {\n  transition:\n    opacity 150ms ease-in,\n    visibility 150ms ease-in;\n  opacity: 1;\n  visibility: visible;\n}\n\n:where(.vds-video-layout[data-sm] .vds-volume[data-active] .vds-tooltip-content) {\n  display: none !important;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Time\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout .vds-time[data-type='current']) {\n  margin-right: 2px;\n}\n\n:where(.vds-video-layout .vds-time[data-type='current'][remainder]) {\n  margin-left: 2px;\n}\n\n.vds-video-layout .vds-time {\n  --default-color: #f5f5f5 !important;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Captions\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where([data-preview] .vds-video-layout .vds-captions) {\n  opacity: 0;\n}\n\n:where(.vds-video-layout .vds-captions) {\n  z-index: 10;\n  transition: var(--video-captions-transition, bottom 0.3s ease-in-out);\n}\n\n@media (min-width: 980px) {\n  :where([data-fullscreen] .vds-video-layout .vds-captions) {\n    bottom: var(--video-lg-fullscreen-captions-offset, 54px);\n  }\n}\n\n:where([data-media-player][data-controls] .vds-video-layout .vds-captions) {\n  bottom: var(--video-captions-offset, 78px);\n}\n\n:where([data-media-player][data-controls] .vds-video-layout[data-sm] .vds-captions) {\n  bottom: var(--video-sm-captions-offset, 48px);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Chapters\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout .vds-time-slider .vds-slider-chapter-title) {\n  width: 100%;\n  text-align: center;\n  text-shadow:\n    -1px -1px 0 #212121,\n    1px -1px 0 #212121,\n    -1px 1px 0 #212121,\n    1px 1px 0 #212121;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Gestures\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout .vds-gesture) {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n:where(.vds-video-layout .vds-gesture[action='seek:-10']) {\n  width: var(--video-gesture-seek-width, 20%);\n  z-index: 1;\n}\n\n:where(.vds-video-layout .vds-gesture[action='seek:10']) {\n  left: unset;\n  right: 0;\n  width: var(--video-gesture-seek-width, 20%);\n  z-index: 1;\n}\n\n@media (pointer: coarse) {\n  :where(.vds-video-layout .vds-gesture[action='toggle:paused']) {\n    display: none;\n  }\n}\n\n@media not (pointer: coarse) {\n  :where([data-media-player] .vds-video-layout .vds-gesture[action='toggle:controls']) {\n    display: none;\n  }\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Live Button\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout .vds-live-button) {\n  margin-left: 12px;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Time Group\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout:not([data-sm]) .vds-time-group) {\n  margin-left: 10px;\n}\n\n:where(.vds-video-layout[data-sm] .vds-time) {\n  font-size: var(--video-sm-time-font-size, 14px);\n}\n\n:where([data-fullscreen] .vds-video-layout .vds-time) {\n  font-size: var(--video-fullscreen-time-font-size, 16px);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Load Container\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout .vds-load-container) {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 99;\n}\n\n:where(\n    [data-media-player][data-load='play']:not([data-started])\n      .vds-video-layout[data-match]\n      .vds-load-container\n  ) {\n  display: flex;\n}\n\n:where(.vds-video-layout .vds-load-container .vds-play-button) {\n  --size: var(--video-load-button-size, 56px);\n  --color: var(--video-load-button-color, rgb(0 0 0 / 0.8));\n  --bg-color: var(--video-load-button-bg, var(--media-brand));\n\n  --media-button-hover-transform: 0;\n  --media-button-border: var(--video-load-button-border, var(--color));\n  --media-button-hover-bg: var(--video-load-button-bg, var(--media-brand));\n\n  width: var(--size);\n  height: var(--size);\n  pointer-events: auto;\n  margin-bottom: 2px;\n  overflow: hidden;\n}\n\n.vds-video-layout .vds-load-container .vds-play-button {\n  border-radius: var(--video-load-button-border-radius, 100%);\n  color: var(--color);\n}\n\n.vds-video-layout .vds-load-container .vds-play-button {\n  background-color: var(--bg-color);\n}\n\n:where(.vds-video-layout[data-sm] .vds-load-container .vds-play-button) {\n  --size: var(--video-sm-load-button-size, 48px);\n  --media-button-hover-transform: translateY(0%);\n  width: var(--size);\n  height: var(--size);\n  transform: translateY(0%);\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Small Layout\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where(.vds-video-layout[data-sm] .vds-controls-group:nth-last-child(2)) {\n  pointer-events: none;\n}\n\n:where(.vds-video-layout[data-sm] .vds-controls-group:last-child) {\n  z-index: 2;\n  margin-top: -2.5px;\n  margin-bottom: -6px;\n}\n\n:where([data-fullscreen] .vds-video-layout[data-sm] .vds-controls-group:last-child) {\n  margin-bottom: 0;\n}\n\n.vds-video-layout[data-sm] .vds-controls-group {\n  padding: 2px;\n}\n\n:where(.vds-video-layout[data-sm])\n  :where(\n    .vds-button,\n    .vds-slider:not(.vds-time-slider),\n    .vds-time,\n    .vds-time-divider,\n    .vds-chapter-title\n  ) {\n  transition: opacity 0.15s ease;\n}\n\n:where([data-media-player]:not([data-started]) .vds-video-layout[data-sm])\n  :where(.vds-button .vds-slider, .vds-time-group) {\n  opacity: 0;\n  visibility: hidden;\n}\n\n:where(.vds-video-layout[data-sm] .vds-time-slider) {\n  transition: transform 0.1s linear;\n}\n\n@media (pointer: coarse) {\n  :where([data-preview] .vds-video-layout:not([data-no-scrub-gesture]))\n    :where(\n      .vds-button,\n      .vds-slider:not(.vds-time-slider),\n      .vds-time,\n      .vds-chapter-title,\n      .vds-time-divider,\n      .vds-captions,\n      .vds-live-button\n    ) {\n    opacity: 0;\n  }\n\n  :where([data-preview] .vds-video-layout:not([data-no-scrub-gesture]) .vds-time-slider) {\n    --track-height: var(--video-sm-slider-focus-track-height, 12px);\n    transform: translateY(-6px);\n    transition: transform 0.1s linear;\n  }\n}\n\n:where(.vds-video-layout[data-sm] .vds-controls .vds-play-button) {\n  --size: var(--video-sm-play-button-size, 45px);\n  --media-button-hover-transform: translateY(25%);\n  width: var(--size);\n  height: var(--size);\n  transform: translateY(25%);\n  border-radius: 100%;\n  pointer-events: auto;\n  margin-bottom: 2px;\n  overflow: hidden;\n}\n\n.vds-video-layout[data-sm] .vds-controls .vds-play-button {\n  background-color: var(--video-sm-play-button-bg, rgba(0 0 0 / 0.6));\n}\n\n:where(\n    [data-media-player]:not([data-started])\n      .vds-video-layout[data-sm]\n      .vds-controls-group:not(:nth-child(3))\n  ) {\n  opacity: 0;\n  visibility: hidden;\n}\n\n/* center big play button inside buffering indicator. */\n:where(.vds-video-layout[data-sm] .vds-buffering-indicator) {\n  --media-buffering-size: 64px;\n  transform: translate(-2px, -4px);\n}\n\n:where(.vds-video-layout .vds-start-duration .vds-time) {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  z-index: 10;\n}\n\n.vds-video-layout .vds-start-duration .vds-time {\n  padding: var(--video-sm-start-duration-padding, 3px 6px);\n  color: var(--video-sm-start-duration-color, var(--video-controls-color));\n  background-color: var(--video-sm-start-duration-bg, rgba(0 0 0 / 0.64));\n}\n\n:where([data-started] .vds-video-layout .vds-start-duration .vds-time) {\n  display: none;\n}\n\n:where([data-media-player]:not([data-can-play]) .vds-video-layout .vds-start-duration .vds-time) {\n  opacity: 0;\n}\n\n:where(.vds-video-layout[data-sm] .vds-time[data-type='current']) {\n  margin-left: 8px;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Fullscreen\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\n\n:where([data-fullscreen] .vds-video-layout .vds-controls-group:nth-last-child(2)) {\n  margin-bottom: -16px;\n}\n\n@media (orientation: portrait) {\n  :where([data-fullscreen] .vds-video-layout .vds-captions) {\n    bottom: 30lvh;\n    bottom: 10dvh;\n  }\n}\n\n@media (orientation: landscape) {\n  :where([data-fullscreen] .vds-video-layout .vds-controls-group:nth-last-child(2)) {\n    margin-bottom: -12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
